<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de inconsistência">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/raas/relatorio-inconsistencia/List'

export default {
    components: {List},
}
</script>